<div mat-dialog-title class="dialog-title p-3 pr-5">
  <h5>Note</h5>
  <button
    mat-icon-button
    aria-label="Close dialog"
    matTooltip="Close this dialog."
    mat-dialog-close
    class="dialog-close-button">
    <mat-icon>close</mat-icon>
  </button>
</div>

<form #f="ngForm" (ngSubmit)="onSubmit(f)">

  <hr class="m-0 p-0">

  <mat-dialog-content class="px-3 py-4">
    <mat-form-field class="full-width mb-2" appearance="outline">
      <mat-label>Note</mat-label>
      <textarea matInput placeholder="Note" [(ngModel)]="note.note" name="note" required #noteRef rows="10"></textarea>
      <mat-error *ngIf="!noteRef.valid">Please enter a note.</mat-error>
    </mat-form-field>
  </mat-dialog-content>

  <hr class="m-0 p-0">

  <mat-dialog-actions class="p-3">
    <button
      mat-raised-button
      [disabled]="!f.valid || inProgress"
      color="primary"
      type="submit"
      id="save"
      *ngIf="canEdit">
      <mat-icon>save</mat-icon>
      Save
    </button>

    <button
      class="dialog-remove-button m-1 ml-auto"
      type="button"
      mat-icon-button
      [disabled]="inProgress"
      *ngIf="data.noteId && canEdit"
      (click)="onDelete()">
      <mat-icon>delete</mat-icon>
    </button>
  </mat-dialog-actions>

</form>
